var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _vm.video_id != null && _vm.video_id != ""
      ? _c("div", { staticClass: "video-wrapper w-100" }, [
          _c(
            "div",
            {
              ref: "plyr",
              staticClass: "plyr__video-embed",
              attrs: { id: "full-width-player" }
            },
            [
              _c("iframe", {
                attrs: {
                  src:
                    "https://player.vimeo.com/video/" +
                    _vm.video_id +
                    "?loop=true&autopause=false&width=1024&controls=false&transparent=false&gesture=media&dnt=true",
                  allowfullscreen: "",
                  allowtransparency: "",
                  allow: "autoplay"
                }
              })
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }